import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuPortal,
} from "app/components/shared/DropdownMenu";
import Icon from "app/components/shared/Icon";
import { useBuildPreferencesStore } from "../../lib/useBuildPreferencesStore";

export function TableActionsDropdown() {
  const resetColumnWidths = useBuildPreferencesStore((state) => state.resetColumnWidths);

  return (
    <div className="flex justify-end w-full">
      <DropdownMenu>
        <DropdownMenuTrigger asChild={true}>
          <button className="items-center flex p-0.5 hover:text-purple-600 hover:bg-purple-100 rounded-md">
            <Icon icon="heroicons/solid/ellipsis-vertical" className="w-5 h-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuPortal>
          <DropdownMenuContent>
            <button
              className="py-1 rounded-md transition-colors flex items-center truncate max-w-full px-2 self-center font-normal text-charcoal-600 hover:bg-gray-200 hover:border-gray-300"
              onClick={resetColumnWidths}
            >
              <span>Reset all column widths</span>
            </button>
          </DropdownMenuContent>
        </DropdownMenuPortal>
      </DropdownMenu>
    </div>
  );
}
